import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Label, ButtonToolbar, Button } from 'reactstrap';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import { green, yellow, red } from '@material-ui/core/colors';
import DateField from './form/DateField';
import Select from './form/Select';
import renderCheckBoxField from './form/CheckBox';
import { classListActivesByFunc } from '../queries/SchoolClass';
import { studentListByFilter } from '../queries/Student';
import {
  itensTabletActiveListByNivel,
  employeeListByFilter,
} from '../queries/Appointment';
import GraphQl from '../../GraphQL';
import { STATUS_AUDIT } from '../utils/constants';

const StudentRecordFilter = (props) => {
  const {
    t,
    filterClick,
    initialize,
    lastFilter,
    showLoading,
    hideLoading,
    showSyncFilter,
    showEmployeeFilter,
    showItemsFilter,
  } = props;
  const [items, setItems] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [filter, setFilter] = useState({
    initialDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    ),
    finalDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    ),
    normalSinc: true,
    regularSinc: true,
    badSinc: true,
    status: STATUS_AUDIT.PENDING,
  });

  const loadingAction = {
    HIDE: 'HIDE',
    SHOW: 'SHOW',
  };

  function dealWithLoading(action) {
    if (action === loadingAction.SHOW && showLoading) {
      showLoading();
    }
    if (action === loadingAction.HIDE && hideLoading) {
      hideLoading();
    }
  }

  const loadItemsTablet = () => {
    const query = itensTabletActiveListByNivel();
    dealWithLoading(loadingAction.SHOW);
    GraphQl(query, {})
      .then((res) => {
        setItems(res.itensTabletActiveListByNivel);
        dealWithLoading(loadingAction.HIDE);
      })
      .catch((error) => {
        console.error(error);
        dealWithLoading(loadingAction.HIDE);
      });
  };

  const listItems = () => {
    loadItemsTablet();
  };

  const listClasses = () => {
    const query = classListActivesByFunc();
    dealWithLoading(loadingAction.SHOW);
    GraphQl(query, {})
      .then((res) => {
        setClasses(res.classListActivesByFunc);
        dealWithLoading(loadingAction.HIDE);
      })
      .catch((error) => {
        console.error(error);
        dealWithLoading(loadingAction.HIDE);
      });
  };

  const listStudents = () => {
    const studentFilter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    dealWithLoading(loadingAction.SHOW);
    const query = studentListByFilter(studentFilter);
    GraphQl(query, {})
      .then((res) => {
        setStudents(res.studentListByFilter);
        dealWithLoading(loadingAction.HIDE);
      })
      .catch((error) => {
        console.error(error);
        dealWithLoading(loadingAction.HIDE);
      });
  };

  const listEmployees = () => {
    const query = employeeListByFilter();
    dealWithLoading(loadingAction.SHOW);
    GraphQl(query, {})
      .then((res) => {
        setEmployees(res.employeeListByFilter);
        dealWithLoading(loadingAction.HIDE);
      })
      .catch((error) => {
        console.error(error);
        dealWithLoading(loadingAction.HIDE);
      });
  };

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  const filterNormalSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('normalSinc', evt.target.checked);
    } else {
      filterChange('normalSinc', true);
    }
  };

  const filterRegularSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('regularSinc', evt.target.checked);
    }
  };
  const filterBadSincCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('badSinc', evt.target.checked);
    }
  };

  useEffect(() => {
    listItems();
    listClasses();
    listStudents();
    if (showSyncFilter) {
      listEmployees();
    }
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
    filterClick(filter);
  }, []);

  return (
    <Fragment>
      <form className="form">
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                value={filter.initialDate}
                onChange={(value) => filterChange('initialDate', value)}
                maxDate={filter.finalDate}
                placeholder={t('general.initial_date')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                value={filter.finalDate}
                minDate={filter.initialDate}
                onChange={(value) => filterChange('finalDate', value)}
                placeholder={t('general.final_date')}
              />
            </div>
          </div>
        </div>
        {showItemsFilter && (
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.itens')}</span>
            <div className="form__form-group-field">
              <Field
                name="itens"
                type="text"
                component={Select}
                isMulti
                closeMenuOnSelect={false}
                placeholder={t('general.itens')}
                options={items}
                onChange={(values) => filterChange('itens', values)}
              />
            </div>
          </div>
        )}
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="classes"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={classes}
              onChange={(values) => filterChange('classes', values)}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={students}
              onChange={(values) => filterChange('students', values)}
              placeholder={t('general.students')}
            />
          </div>
        </div>
        {showEmployeeFilter ? (
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.employees')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="employees"
                type="text"
                closeMenuOnSelect={false}
                component={Select}
                isMulti
                options={employees}
                onChange={(values) => filterChange('employees', values)}
                placeholder={t('general.employees')}
              />
            </div>
          </div>
        ) : null}

        {showSyncFilter ? (
          <>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('mnt_appointment.synchronization_time.title')}
              </span>
            </div>
            <div className="form__form-group--3_columns">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field
                    name="normalSinc"
                    component={renderCheckBoxField}
                    className="colored-click"
                    onChange={filterNormalSincCheckChange}
                    checked={filter.normalSinc}
                  />
                  <Label
                    style={{ paddingRight: '5px' }}
                    className="form__form-group-label"
                  >
                    {t('mnt_appointment.synchronization_time.less-than-1-hour')}
                  </Label>
                  <span
                    className="tooltip-test"
                    title={t(
                      'mnt_appointment.synchronization_time.less-than-1-hour'
                    )}
                  >
                    <AccessTimeOutlinedIcon style={{ color: green[500] }} />
                  </span>
                </div>
              </div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field
                    name="regularSinc"
                    component={renderCheckBoxField}
                    defaultValue
                    className="colored-click"
                    checked={filter.regularSinc}
                    onChange={filterRegularSincCheckChange}
                  />
                  <Label
                    style={{ paddingRight: '5px' }}
                    className="form__form-group-label"
                  >
                    {t(
                      'mnt_appointment.synchronization_time.between-1-and-4-hours'
                    )}
                  </Label>
                  <span
                    className="tooltip-test"
                    title={t(
                      'mnt_appointment.synchronization_time.between-1-and-4-hours'
                    )}
                  >
                    <AccessTimeOutlinedIcon style={{ color: yellow[700] }} />
                  </span>
                </div>
              </div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <Field
                    name="badSinc"
                    component={renderCheckBoxField}
                    className="colored-click"
                    checked={filter.badSinc}
                    onChange={filterBadSincCheckChange}
                  />
                  <Label
                    style={{ paddingRight: '5px' }}
                    className="form__form-group-label"
                  >
                    {t(
                      'mnt_appointment.synchronization_time.more-than-4-hours'
                    )}
                  </Label>
                  <span
                    className="tooltip-test"
                    title={t(
                      'mnt_appointment.synchronization_time.more-than-4-hours'
                    )}
                  >
                    <AccessTimeOutlinedIcon style={{ color: red[500] }} />
                  </span>
                </div>
              </div>
            </div>
          </>
        ) : null}
        <div className="form__form-group">
          <ButtonToolbar className="filter-button">
            <Button color="success" onClick={() => filterClick(filter)}>
              {t('general.filter')}
            </Button>
          </ButtonToolbar>
        </div>
      </form>
    </Fragment>
  );
};

StudentRecordFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
  showSyncFilter: PropTypes.bool,
  showEmployeeFilter: PropTypes.bool,
  showLoading: PropTypes.func,
  hideLoading: PropTypes.func,
  showItemsFilter: PropTypes.bool,
};

StudentRecordFilter.defaultProps = {
  lastFilter: null,
  showLoading: null,
  hideLoading: null,
  showSyncFilter: true,
  showEmployeeFilter: true,
  showItemsFilter: true,
};

export default reduxForm({
  form: 'StudentRecordFilter',
})(withTranslation('common')(StudentRecordFilter));
